import { LocalStorageAdapter } from './local-storage';

export class SessionStorageAdapter extends LocalStorageAdapter {
  get storage() {
    return window.sessionStorage;
  }
}
